import {
  FeatureToggleProvider,
  useGetFeatureToggleVariant,
  type FeatureConfig,
} from '@seek/hirer-feature-toggle';

// @NOTE: These values must match the feature flag key in LD (name the variable with FEATURE_KEY_ prefix for consistency)
export const FEATURE_EXPERIMENT_EXAMPLE = 'experiment-example';
export const FEATURE_RELEASE_EXAMPLE = 'release-example';

const featureConfigs: FeatureConfig[] = [
  {
    key: FEATURE_RELEASE_EXAMPLE,
    name: 'Release Example',
    description: 'This is an example release toggle',
    variants: [true, false],
    fallback: false,
  },
  {
    key: FEATURE_EXPERIMENT_EXAMPLE,
    name: 'Experiment Example',
    description: 'This is an example experiment toggle',
    variants: ['control', 'variant-a', 'variant-b', 'variant-c'],
    fallback: 'control',
  },
];

export { FeatureToggleProvider, featureConfigs, useGetFeatureToggleVariant };
